import React from 'react';
import { Section } from './ui/Section';
export function FAQ() {
  const faqs = [{
    q: '¿Y si ya compré cursos y no funcionó?',
    a: 'Perfecto. Eso es exactamente por qué este protocolo existe. No te faltaba información. Te faltaba un sistema diario ejecutable.'
  }, {
    q: '¿Necesito experiencia previa?',
    a: 'No. Empiezas como operador, no como experto.'
  }, {
    q: '¿Y si no tengo dinero para invertir?',
    a: 'Mejor. Este sistema está diseñado para gente sin capital.'
  }, {
    q: '¿Cuánto tiempo toma al día?',
    a: '60–120 minutos diarios.'
  }];
  return <Section className="bg-gray-50" data-id="element-19">
      <h2 className="text-4xl font-bold mb-12 uppercase" data-id="element-20">
        Preguntas Frecuentes
      </h2>
      <div className="grid md:grid-cols-2 gap-8" data-id="element-21">
        {faqs.map((faq, idx) => <div key={idx} className="bg-white p-6 shadow-sm border border-gray-200" data-id="element-22">
            <h3 className="font-bold text-lg mb-3 flex items-start" data-id="element-23">
              <span className="text-red-600 mr-2" data-id="element-24">?</span> {faq.q}
            </h3>
            <p className="text-gray-600 ml-5" data-id="element-25">{faq.a}</p>
          </div>)}
      </div>
    </Section>;
}